module.exports = __webpack_public_path__ + "img/Azrtxb  oard – 2.9ebeca34.png";